import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/AIAgentFooter.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/AIAgentZaynHeroSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/InterviewBottleneckSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/Navbar.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ScrollReveal.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/WhatZaynDoesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynAiTeamSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynCapabilitiesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynCtaBannerSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynFaqsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynHowItWorksSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynLanguagesSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynProcessStepsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynScorecardSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynTestimonialsSection.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/arooba/getgeek-website-v2/src/components/ZaynTrustSection.jsx");
